import { dataTrendReport } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendReport = /*#__PURE__*/createIcon(dataTrendReport)
export default IconTrendReport
